// extracted by mini-css-extract-plugin
export default {"spinner":"RingsSpinner_spinner__I45Ls","spin":"RingsSpinner_spin__ApElj"};